import React, { useEffect, useRef } from 'react';
import Icon from 'components/AppIcon';

export default function FormErrorBanner({ error, onDismiss }) {
  const timerRef = useRef(null);

  useEffect(() => {
    if (!error) return;
    timerRef.current = setTimeout(() => {
      onDismiss?.();
    }, 8000);
    return () => clearTimeout(timerRef?.current);
  }, [error, onDismiss]);

  if (!error) return null;

  const message = typeof error === 'string' ? error : error?.message || 'An error occurred. Please try again.';

  return (
    <div
      className="flex items-start gap-3 px-4 py-3 rounded-lg mb-4"
      style={{
        backgroundColor: 'rgba(220,38,38,0.08)',
        borderLeft: '3px solid #DC2626',
        border: '1px solid rgba(220,38,38,0.25)',
        borderLeftWidth: 3,
      }}
      role="alert"
    >
      <Icon name="AlertCircle" size={16} color="#DC2626" className="flex-shrink-0 mt-0.5" />
      <p className="flex-1 text-sm" style={{ fontFamily: 'var(--font-caption)', color: '#DC2626' }}>
        {message}
      </p>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="flex-shrink-0 hover:opacity-70 transition-opacity"
          aria-label="Dismiss error"
        >
          <Icon name="X" size={14} color="#DC2626" />
        </button>
      )}
    </div>
  );
}
